import Modal from "react-bootstrap/Modal";
import logoPNG from "../../assets/images/logo.png";
import IconWhitCheck from "../../assets/svg/white_check.svg";
import IconError from "../../assets/svg/error.svg";
import style from "./modal.module.css";
function Loading(props) {
  const { messageModal, show, setShow, iconToShow } = props;
  const handleClose = () => setShow(false);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName={`rounded-4 overflow-hidden border border-0 bg-brand ${style.modal_loading}`}
        backdropClassName={style.modal_backdrop}
      >
        <Modal.Body className="text-light">
          <div className="d-flex flex-column align-items-center text-center py-3 px-5">
            <img
              src={logoPNG}
              alt="Apito"
              className={style.modal_size_image_logo_loading}
            />
            {iconToShow === "success" ? (
              <div className="mt-4">
                <img
                  src={IconWhitCheck}
                  alt="White Icon Check"
                  style={{ width: "40px", height: "auto" }}
                />
              </div>
            ) : iconToShow === "error" ? (
              <div className="mt-4">
                <img
                  src={IconError}
                  alt="White Icon Check"
                  style={{ width: "40px", height: "auto" }}
                />
              </div>
            ) : (
              <div className="spinner-border text-light mt-4" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
            <div className="text-light fs-4 fw-bold">{messageModal}</div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
var Loading_default = Loading;
export {
  Loading_default as default
};